import { combineReducers } from '@reduxjs/toolkit'

import {
  DELETE_PROFILE_REDUCER_NAME,
  PROFILES_LIST_REDUCER_NAME,
} from 'features/profiles/consts'
import {
  deleteProfileReducer,
  profilesListReducer,
} from 'features/profiles/slice'

export default combineReducers({
  [PROFILES_LIST_REDUCER_NAME]: profilesListReducer,
  [DELETE_PROFILE_REDUCER_NAME]: deleteProfileReducer,
})
